import { render, staticRenderFns } from "./MetabaseDashboard.vue?vue&type=template&id=a7ed1a04&scoped=true&"
import script from "./MetabaseDashboard.vue?vue&type=script&lang=js&"
export * from "./MetabaseDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ed1a04",
  null
  
)

export default component.exports